import { render, staticRenderFns } from "./CompanySwitch.vue?vue&type=template&id=632b90dc&"
import script from "./CompanySwitch.vue?vue&type=script&lang=js&"
export * from "./CompanySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports